/**
 * 타임존 변환 유틸리티 함수
 * UTC → EST/EDT (자동 서머타임 처리) 및 KST 변환
 */

/**
 * UTC 시간을 EST/EDT로 변환 (24시간 형식)
 * @param utcTime ISO 8601 UTC 타임스탬프 (예: "2025-10-21T18:30:00Z")
 * @returns EST/EDT 시간 문자열 (예: "2025-10-21 14:30:00")
 */
export function convertUTCtoEST(utcTime: string): string {
  try {
    const date = new Date(utcTime);

    // America/New_York 타임존으로 변환 (EST/EDT 자동 처리)
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });

    const parts = formatter.formatToParts(date);
    const values: Record<string, string> = {};

    parts.forEach((part) => {
      if (part.type !== 'literal') {
        values[part.type] = part.value;
      }
    });

    return `${values.year}-${values.month}-${values.day} ${values.hour}:${values.minute}:${values.second}`;
  } catch (error) {
    console.error('Error converting UTC to EST:', error);
    return 'Invalid Date';
  }
}

/**
 * UTC 시간을 KST로 변환 (24시간 형식)
 * @param utcTime ISO 8601 UTC 타임스탬프 (예: "2025-10-21T18:30:00Z")
 * @returns KST 시간 문자열 (예: "2025-10-22 03:30:00 KST")
 */
export function convertUTCtoKST(utcTime: string): string {
  try {
    const date = new Date(utcTime);

    // Asia/Seoul 타임존으로 변환
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Asia/Seoul',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });

    const parts = formatter.formatToParts(date);
    const values: Record<string, string> = {};

    parts.forEach((part) => {
      if (part.type !== 'literal') {
        values[part.type] = part.value;
      }
    });

    return `${values.year}-${values.month}-${values.day} ${values.hour}:${values.minute}:${values.second} KST`;
  } catch (error) {
    console.error('Error converting UTC to KST:', error);
    return 'Invalid Date';
  }
}
